import { AxiosError } from 'axios';
import { useQueryClient } from 'react-query';
import { UpdateCandidateProfileDetailsRequest } from '../../api/user/model';
import { PUT_CANDIDATE_PROFILE_DETAILS_FOR_OPS_ADMIN_URL } from '../../constants/apiUrls';
import { GET_SPE_ADDITIONAL_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutCandidateProfileDetailsForOpsAdmin = ({ onSuccess, onError, uuid }: Input) => {
  const queryClient = useQueryClient();

  const putCandidateProfileDetailsForOpsAdmin = async (
    reqBody: UpdateCandidateProfileDetailsRequest
  ) => {
    await axiosClient.put(PUT_CANDIDATE_PROFILE_DETAILS_FOR_OPS_ADMIN_URL(uuid), reqBody);
  };

  return useCustomMutation(putCandidateProfileDetailsForOpsAdmin, {
    onSuccess: () => {
      queryClient.invalidateQueries(GET_SPE_ADDITIONAL_DETAILS_QUERY_KEY);
      onSuccess?.();
    },
    onError,
  });
};
